import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { AgmCoreModule } from '@agm/core';

import { NotFoundComponent } from './not-found/not-found.component';
import { FileListComponent } from './file-list';
import { UploaderComponent } from './uploader';
import { InfoBusinessComponent } from './account/info-business/info-business.component';
import { InfoUserComponent } from './account/info-user/info-user.component';
import {
  AddDistributorsComponent,
  CreateDistributorsComponent
} from './distributors';
import {
  DocumentAddComponent,
  DocumentUpdateComponent,
  DocumentDeleteComponent,
  DocumentSelectComponent
} from './documents';
import {
  AddStoresComponent,
  CreateStoresComponent,
  VerifyStoresComponent,
  BlockStoresComponent,
  FormStoresComponent,
  AssignStoresComponent
} from './stores';
import { DeletePopupComponent } from './delete-popup/delete-popup.component';
import { ListProductComponent } from './list-product/list-product.component';
import { TranferItemComponent } from './tranfer-item/tranfer-item.component';
import { ChangePasswordComponent } from './account/change-password/change-password.component';
import {ContactPopupComponent} from './contact-popup/contact-popup.component';
import {NgxSummernoteModule} from 'ngx-summernote';
import {VisibleContentDirective} from './directive/visible-content.directive';
import {ModalCategoryComponent} from './category/modal-category/modal-category.component';
import {CategoryComponent} from './category/category.component';
import {HoverTooltipDirective} from "./directive/hover-tooltip.directive";
import {environment} from '../../environments/environment';

@NgModule({
  declarations: [
    FileListComponent,
    UploaderComponent,
    NotFoundComponent,
    InfoBusinessComponent,
    InfoUserComponent,
    CreateDistributorsComponent,
    AddDistributorsComponent,
    CategoryComponent,
    DocumentAddComponent,
    DocumentUpdateComponent,
    AddStoresComponent,
    CreateStoresComponent,
    VerifyStoresComponent,
    BlockStoresComponent,
    DeletePopupComponent,
    ContactPopupComponent,
    DocumentDeleteComponent,
    ListProductComponent,
    ModalCategoryComponent,
    DocumentSelectComponent,
    TranferItemComponent,
    ChangePasswordComponent,
    FormStoresComponent,
    AssignStoresComponent,
    VisibleContentDirective,
    HoverTooltipDirective
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgZorroAntdModule,
        // map
        AgmCoreModule.forRoot({
            apiKey: environment.googleKeyAPI,
            libraries: ['places']
        }),
        NgxSummernoteModule,
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    UploaderComponent,
    ModalCategoryComponent
  ],
  exports: [
    FileListComponent,
    UploaderComponent,
    InfoUserComponent,
    CreateDistributorsComponent,
    AddDistributorsComponent,
    DocumentAddComponent,
    DocumentUpdateComponent,
    DocumentDeleteComponent,
    AddStoresComponent,
    CreateStoresComponent,
    VerifyStoresComponent,
    BlockStoresComponent,
    DeletePopupComponent,
    ContactPopupComponent,
    ListProductComponent,
    DocumentSelectComponent,
    TranferItemComponent,
    ChangePasswordComponent,
    FormStoresComponent,
    AssignStoresComponent,
    VisibleContentDirective,
    CategoryComponent,
    HoverTooltipDirective
  ]
})
export class SharedModule { }
